import { render } from "./DetailFlashMessages.vue?vue&type=template&id=4088f742"
import script from "./DetailFlashMessages.vue?vue&type=script&lang=js"
export * from "./DetailFlashMessages.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Shared/DetailFlashMessages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4088f742"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4088f742', __exports__)) {
    console.log('reload')
    api.reload('4088f742', __exports__)
  }
  
  module.hot.accept("./DetailFlashMessages.vue?vue&type=template&id=4088f742", () => {
    console.log('re-render')
    api.rerender('4088f742', render)
  })

}


export default __exports__